module.exports = __webpack_public_path__ + "img/payment-future-icon.32c11b60.svg";